import ElipsisImage from 'images/ellipsis-50px'
import { useState } from 'react'

const SmartButtonLink = ({ to, className, disabled, click, children, text, inverted, spinning }) => {
  // State
  const [state, setState] = useState({ spinning: spinning })

  // consts
  let classes = classNames('smart-button btn', className, { processing: state.spinning, inverted: inverted && !state.spinning, disabled: disabled })

  // Hooks

  // Custom Methods
  const onClick = async () => {
    setState({ spinning: true })
    if (click)
      await click()
    setState({ spinning: false })
  }

  return (
    <Link to={to} className={classes} onClick={() => onClick()}>
      <span className="smart-button-text">{children || text}</span>
      {state.spinning && <img src={ElipsisImage} className="smart-button-spinner" />}
    </Link>
  )
}

export default SmartButtonLink
